import React, { useEffect, useState } from 'react';
import { Search, RefreshCw, Trash2 } from 'lucide-react';
import api from '../../api/client';

const AZIONE_COLOR = {
  LOGIN: '#22C55E', LOGIN_FALLITO: '#EF4444', LOGOUT: '#666',
  CREA_ORDINE: '#3B82F6', MODIFICA_ORDINE: '#60A5FA', CAMBIA_STATO_ORDINE: '#93C5FD', ANNULLA_ORDINE: '#EF4444', PAGAMENTO_ORDINE: '#22C55E',
  CREA_PRODOTTO: '#F59E0B', MODIFICA_PRODOTTO: '#FBB044', ELIMINA_PRODOTTO: '#EF4444',
  CARICO_MAGAZZINO: '#22C55E', RETTIFICA_MAGAZZINO: '#F59E0B', SCARICO_MAGAZZINO: '#8B5CF6',
  CREA_CLIENTE: '#A78BFA', MODIFICA_CLIENTE: '#C4B5FD', ELIMINA_CLIENTE: '#EF4444',
  CREA_FORNITORE: '#F472B6', MODIFICA_FORNITORE: '#F9A8D4',
  CREA_ORDINE_ACQUISTO: '#FB923C', RICEVI_MERCE: '#22C55E',
  MODIFICA_SOCIETA: '#F59E0B', CREA_UTENTE: '#3B82F6', MODIFICA_UTENTE: '#60A5FA', DISABILITA_UTENTE: '#F97316', ELIMINA_UTENTE: '#EF4444',
  MOVIMENTO_CASSA: '#A3E635', ELIMINA_MOVIMENTO_CASSA: '#EF4444',
  IMPORT_BANCA: '#22C55E', ELIMINA_TX_BANCA: '#EF4444', ELIMINA_FILE_BANCA: '#F97316', AGGIUNGI_TX_DA_ESTRATTO: '#22C55E',
  CREA_PASSWORD: '#F4600C', MODIFICA_PASSWORD: '#FBB044', ELIMINA_PASSWORD: '#EF4444', VISUALIZZA_PASSWORD: '#3B82F6', ESPORTA_PASSWORD: '#EF4444', ESPORTA_PASSWORD_FALLITO: '#EF4444', RIMUOVI_ATLETA_GRUPPO: '#F59E0B', ELIMINA_ATLETA_GRUPPO: '#EF4444', CAMBIA_PACCHETTO_GRUPPO_AVVIATO: '#F59E0B',
};

const AZIONE_ICON = {
  LOGIN: '🔐', LOGIN_FALLITO: '⛔', LOGOUT: '🚪',
  CREA_ORDINE: '🛒', MODIFICA_ORDINE: '✏️', CAMBIA_STATO_ORDINE: '🔄', ANNULLA_ORDINE: '❌', PAGAMENTO_ORDINE: '💳',
  CREA_PRODOTTO: '📦', MODIFICA_PRODOTTO: '✏️', ELIMINA_PRODOTTO: '🗑️',
  CARICO_MAGAZZINO: '⬆️', SCARICO_MAGAZZINO: '⬇️', RETTIFICA_MAGAZZINO: '⚖️',
  CREA_CLIENTE: '👤', MODIFICA_CLIENTE: '✏️', ELIMINA_CLIENTE: '🗑️',
  CREA_FORNITORE: '🏭', RICEVI_MERCE: '📬', CREA_ORDINE_ACQUISTO: '📋',
  MODIFICA_SOCIETA: '🏢', CREA_UTENTE: '👥', MODIFICA_UTENTE: '✏️', DISABILITA_UTENTE: '🔒', ELIMINA_UTENTE: '🗑️',
  MOVIMENTO_CASSA: '💰', ELIMINA_MOVIMENTO_CASSA: '🗑️',
  IMPORT_BANCA: '🏦', ELIMINA_TX_BANCA: '🗑️', ELIMINA_FILE_BANCA: '🗑️', AGGIUNGI_TX_DA_ESTRATTO: '🏦',
  CREA_PASSWORD: '🔑', MODIFICA_PASSWORD: '✏️', ELIMINA_PASSWORD: '🗑️', VISUALIZZA_PASSWORD: '👁️', ESPORTA_PASSWORD: '⬇️', ESPORTA_PASSWORD_FALLITO: '⛔', RIMUOVI_ATLETA_GRUPPO: '➖', ELIMINA_ATLETA_GRUPPO: '🗑️', CAMBIA_PACCHETTO_GRUPPO_AVVIATO: '🔒',
};

export default function Changelog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterAzione, setFilterAzione] = useState('');
  const [svuotando, setSvuotando] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/changelog', { params: { limit: 500 } });
      setLogs(r.data);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const svuotaLog = async () => {
    if (!window.confirm(`Eliminare tutti i ${logs.length} eventi dal log? L'operazione non è reversibile.`)) return;
    setSvuotando(true);
    try {
      await api.delete('/changelog');
      setLogs([]);
    } catch(e) { console.error(e); }
    finally { setSvuotando(false); }
  };

  useEffect(() => { load(); }, []);

  const filtered = logs.filter(l => {
    const matchSearch = !search || 
      l.user_nome?.toLowerCase().includes(search.toLowerCase()) ||
      l.azione?.toLowerCase().includes(search.toLowerCase()) ||
      l.dettaglio?.toLowerCase().includes(search.toLowerCase());
    const matchAzione = !filterAzione || l.azione === filterAzione;
    return matchSearch && matchAzione;
  });

  const azioniUniche = [...new Set(logs.map(l => l.azione))].sort();

  const formatDettaglio = (det) => {
    if (!det) return null;
    try {
      const obj = JSON.parse(det);
      return Object.entries(obj).map(([k,v]) => `${k}: ${v}`).join(' · ');
    } catch { return det; }
  };

  const groupByDate = (logs) => {
    const groups = {};
    logs.forEach(l => {
      const date = new Date(l.created_at).toLocaleDateString('it-IT');
      if (!groups[date]) groups[date] = [];
      groups[date].push(l);
    });
    return groups;
  };

  const grouped = groupByDate(filtered);

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'24px' }}>
        <div>
          <h1 style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' }}>CHANGELOG OPERATIVO</h1>
          <p style={{ color:'#666', fontSize:'var(--font-size-sm)', marginTop:'4px' }}>{logs.length} eventi registrati</p>
        </div>
        <div style={{ display:'flex', gap:'8px' }}>
          <button style={{ display:'flex', alignItems:'center', gap:'8px', background:'var(--border)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'10px 16px', color:'var(--text-muted)', fontSize:'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' }}
            onClick={load}>
            <RefreshCw size={13}/> AGGIORNA
          </button>
          {logs.length > 0 && (
            <button style={{ display:'flex', alignItems:'center', gap:'8px', background:'#FEE4E2', border:'1px solid #FCA5A5', borderRadius:'8px', padding:'10px 16px', color:'#EF4444', fontSize:'var(--font-size-xs)', fontWeight:'700', cursor: svuotando ? 'not-allowed' : 'pointer', opacity: svuotando ? 0.6 : 1 }}
              onClick={svuotaLog} disabled={svuotando}>
              <Trash2 size={13}/> SVUOTA LOG
            </button>
          )}
        </div>
      </div>

      {/* Filtri */}
      <div style={{ display:'flex', gap:'10px', marginBottom:'20px', flexWrap:'wrap' }}>
        <div style={{ position:'relative', flex:1, minWidth:'200px' }}>
          <Search size={13} color="#555" style={{ position:'absolute', left:'10px', top:'50%', transform:'translateY(-50%)' }} />
          <input style={{ width:'100%', background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'8px', padding:'9px 14px 9px 32px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', boxSizing:'border-box' }}
            placeholder="Cerca utente, azione, dettaglio..."
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select style={{ background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'8px', padding:'9px 14px', color:'var(--text)', fontSize:'var(--font-size-xs)', outline:'none' }}
          value={filterAzione} onChange={e => setFilterAzione(e.target.value)}>
          <option value="">Tutte le azioni</option>
          {azioniUniche.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', color:'var(--text-dim)', padding:'40px' }}>Caricamento...</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
          {Object.entries(grouped).map(([date, dayLogs]) => (
            <div key={date}>
              <div style={{ fontSize:'var(--font-size-xs)', fontWeight:'700', letterSpacing:'2px', color:'var(--text-dim)', marginBottom:'8px', padding:'4px 0', borderBottom:'1px solid var(--border)' }}>
                {date} — {dayLogs.length} eventi
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'4px' }}>
                {dayLogs.map(l => {
                  const color = AZIONE_COLOR[l.azione] || 'var(--text-muted)';
                  const icon = AZIONE_ICON[l.azione] || '•';
                  const det = formatDettaglio(l.dettaglio);
                  return (
                    <div key={l.id} style={{ display:'flex', gap:'12px', alignItems:'flex-start', background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'8px', padding:'10px 14px' }}>
                      <div style={{ fontSize: 'var(--font-size-lg)', flexShrink:0, marginTop:'1px' }}>{icon}</div>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'2px', flexWrap:'wrap' }}>
                          {l.user_nome && (
                            <span style={{ fontSize:'var(--font-size-xs)', fontWeight:'800', color:'var(--text)', background:'var(--bg-input)', borderRadius:'4px', padding:'1px 7px' }}>{l.user_nome}</span>
                          )}
                          <span style={{ background:`${color}18`, color, border:`1px solid ${color}40`, borderRadius:'4px', padding:'1px 8px', fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'0.5px' }}>
                            {l.azione}
                          </span>
                          {l.entita && l.entita_id && (
                            <span style={{ fontSize:'var(--font-size-xs)', color:'var(--text-dim)' }}>{l.entita} #{l.entita_id}</span>
                          )}
                        </div>
                        {det && <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text-dim)', marginTop:'2px' }}>{det}</div>}
                      </div>
                      <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text-dim)', flexShrink:0, marginTop:'2px' }}>
                        {new Date(l.created_at).toLocaleTimeString('it-IT', { hour:'2-digit', minute:'2-digit', second:'2-digit' })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ textAlign:'center', color:'var(--text-dim)', padding:'40px' }}>Nessun evento trovato</div>
          )}
        </div>
      )}
    </div>
  );
}
